module.exports = __webpack_public_path__ + "static/media/galdisa_acerca_de_tiempo_1998.36bdd0bf.jpg";